import { useEffect, type CSSProperties } from "react";
import { useEmbedTokens } from "../theme";

const SPIN_STYLE_ID = "aldelo-embed-spin";

// Inline styles cannot define @keyframes, so inject a single idempotent
// <style> that declares ONLY the keyframe (no host selectors touched).
function ensureKeyframes(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(SPIN_STYLE_ID)) return;
  const el = document.createElement("style");
  el.id = SPIN_STYLE_ID;
  el.textContent = "@keyframes aldelo-spin{to{transform:rotate(360deg)}}";
  document.head.appendChild(el);
}

export function EmbedSpinner({ size = 18, onColor = false }: { size?: number; onColor?: boolean }) {
  const t = useEmbedTokens();
  useEffect(() => { ensureKeyframes(); }, []);
  const track = onColor ? "rgba(255,255,255,0.4)" : t.colors.primaryTint;
  const head = onColor ? t.colors.white : t.colors.primary;
  const style: CSSProperties = {
    width: size, height: size, borderRadius: "50%",
    border: `2px solid ${track}`, borderTopColor: head,
    animation: "aldelo-spin .7s linear infinite",
    display: "inline-block", verticalAlign: "middle", boxSizing: "border-box", flex: "none",
  };
  return <span role="status" aria-label="Loading" style={style} />;
}
